import angular from 'angular';
import CategoriesAccordion from './categories-accordion.component';

let CategoriesAccordionModule = angular.module('catalog.categoriesAccordion', [])
  .component('categoriesAccordion', CategoriesAccordion);

export default CategoriesAccordionModule;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/catalog/categories-filter/categories-accordion/categories-accordion.js
 **/